import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'
import styles from './StatusBadge.module.scss'

const propTypes = {
  /**
   * Content of the badge
   */
  children: PropTypes.node.isRequired,
  /**
   * Color variant of the badge
   */
  variant: PropTypes.oneOf(['success', 'danger', 'warning', 'info', 'secondary']),
  /**
   * Additional CSS class
   */
  className: PropTypes.string,
  /**
   * Custom left margin for alignment
   */
  marginLeft: PropTypes.string,
  /**
   * Badge size; compact suits dense rows of several badges
   */
  size: PropTypes.oneOf(['default', 'compact']),
}

function StatusBadge(props) {
  const { children, variant = 'secondary', className = '', marginLeft = undefined, size = 'default' } = props ?? {}

  return (
    <span
      className={clsx(styles.badge, styles[variant], { [styles.compact]: size === 'compact' }, className)}
      style={{
        ...(marginLeft && { marginLeft }),
      }}
    >
      {children}
    </span>
  )
}

StatusBadge.propTypes = propTypes

export default StatusBadge
